<script lang="ts" setup>
import type { FerryAutoCompleteSuggestion } from '@libs/trip-planner-interfaces';
import { AppHighlighter, AppSvgIcon } from '@libs/ui';

interface FerryRouteItemProps {
  item: FerryAutoCompleteSuggestion;
  autoCompleteText?: string;
}

const props = defineProps<FerryRouteItemProps>();
</script>

<template>
  <div class="ferry-route-item">
    <div class="origin-seaport">
      <div class="seaport-name">
        <AppHighlighter
          :text="props.item.data.from.label"
          :search-text="props.autoCompleteText || ''"
        />
      </div>
      <div class="seaport-details">
        <AppHighlighter
          :text="props.item.data.from.country"
          :search-text="props.autoCompleteText || ''"
        />
      </div>
    </div>
    <div class="seaport-separator">
      <div class="separator-icon">
        <AppSvgIcon name="ferry" size="18" />
      </div>
    </div>
    <div class="destination-seaport">
      <div class="seaport-name">
        <AppHighlighter
          :text="props.item.data.to.label"
          :search-text="props.autoCompleteText || ''"
        />
      </div>
      <div class="seaport-details">
        <AppHighlighter
          :text="props.item.data.to.country"
          :search-text="props.autoCompleteText || ''"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ferry-route-item {
  width: 100%;

  border-radius: var(--border-radius-12);
  padding: var(--spacing-12);

  display: flex;
  gap: var(--spacing-8);
  cursor: pointer;

  .origin-seaport {
    align-items: flex-end;
    .seaport-details,
    .seaport-name {
      text-align: right;
    }
  }

  .origin-seaport,
  .destination-seaport {
    display: flex;
    flex-direction: column;
    width: calc(50% - var(--spacing-32) - (var(--spacing-12) / 2));
    gap: var(--spacing-4);

    .seaport-name {
      @include font-label-l-light;
    }

    .seaport-details {
      @include font-label-s-light;
      .font-bold {
        @include font-label-s-bold;
      }
    }
  }

  .seaport-separator {
    width: var(--spacing-64);
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      background-color: var(--color-neutral-30);
      top: 50%;
      transform: translateY(-50%);
      z-index: 1;
    }

    .separator-icon {
      position: relative;
      z-index: 2;
      width: var(--spacing-32);
      height: var(--spacing-32);
      background-color: var(--color-neutral-30);
      border-radius: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
